import styled from 'styled-components'
import {
  space, color, layout, SpaceProps, ColorProps, LayoutProps, FlexboxProps, flexbox
} from 'styled-system'
import { textStyle } from '@zuto/utilities'
import { TextStyle } from '@zuto/types'

interface BoxProps extends SpaceProps, ColorProps, LayoutProps, FlexboxProps {
  textStyle?: TextStyle
}

const Box = styled.div<BoxProps>(
  {
    boxSizing: 'border-box',
    minWidth: 0
  },
  space,
  color,
  layout,
  textStyle,
  flexbox
)

export default Box
